import { EmptyState } from '@monorepo/shared/componentsV2/EmptyState';
import {
  Page,
  Title,
} from '@monorepo/shared/componentsV2/fullPageWizard/styled/fullPageWizard';
import { FullScreenLoadingPage } from '@monorepo/shared/componentsV2/Loading';
import { useDisableSubnav } from '@monorepo/shared/hooks/subnav/useDisableSubnav';
import { bodySmall } from '@monorepo/shared/styles/text';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useFormTemplateContext } from '../EditFormTemplatePage/FormTemplateContext';
import { MainContent, StyledMain } from '../FormTemplateEditor/styled';
import { WizardStep } from '../shared/consts';
import { FormTemplateHeader } from '../shared/FormTemplateHeader';
import { useSubmitOnCalendarsTab } from './useSubmitOnCalendarsTab';

const Instructions = styled('span')`
  ${bodySmall}
`;

export function EditFormCalendarsPage({
  formWizardBasePath,
}: {
  formWizardBasePath: string;
}) {
  useDisableSubnav();
  const { organizationId } = useParams();

  if (!organizationId) {
    throw new Error(
      "EditFormCalendarsPage was rendered with a url that doesn't have organizationId",
    );
  }

  const { formTemplate, isDirty, isLoading, isError } =
    useFormTemplateContext();

  const { onSubmit, isSubmitting } = useSubmitOnCalendarsTab({
    formTemplate,
    organizationId,
  });

  if (isLoading) return <FullScreenLoadingPage />;

  return isError ? (
    <EmptyState primaryText="There was a problem loading the form." />
  ) : (
    <Page>
      <FormTemplateHeader
        formWizardBasePath={formWizardBasePath}
        canSubmit={isDirty}
        isEditMode // calendars can only be assigned to form templates that are saved
        organizationId={organizationId}
        wizardStep={WizardStep.CALENDARS}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
      />
      <StyledMain>
        <MainContent>
          <Title>Site Assignments</Title>
          <Instructions>
            Assigning a form to a site will create a new calendar widget on the
            Site’s Inspections page.
          </Instructions>
        </MainContent>
      </StyledMain>
    </Page>
  );
}
